import axiosHttp from "./interceptor.service";

const postShift = (data) => {
  return axiosHttp.post("/lmt/shiftSlot", data);
};

const getShiftById = (id) => {
  return axiosHttp.get(`/lmt/getShiftSlot/${id}`);
};
const getAllShift = () => {
  return axiosHttp.get("/lmt/getAllShiftSlot");
};

const updateShift = (id, data) => {
  return axiosHttp.put(`/lmt/updateShiftSlot/${id}`, data);
};

const deleteShift = (id) => {
  return axiosHttp.delete(`/lmt/deleteShiftSlot/${id}`);
};

export { postShift, getShiftById, getAllShift, updateShift, deleteShift };
